<app-header-modal [color]="'secondary-2'" title="Dados do Relatório">
  <div icon *ngIf="showPalletDetails">
    <i class="uil uil-arrow-left" (click)="goBackToReport()"></i>
  </div>
  <div class="status-header" status>
    <app-status-header-modal
      [icon]="report.state === 'APPROVED' ? 'check' : report.state === 'REJECTED' ? 'times' : 'spinner-alt'"
      [status]="getCrateState(report.state)"
      [color]="report.state === 'APPROVED' ? 'success' : report.state === 'REJECTED' ? 'alert' : 'warning'">
    </app-status-header-modal>
    <i class="uil uil-times" (click)="close('CANCELED')"></i>
  </div>
</app-header-modal>

<mat-tab-group mat-align-tabs="center" *ngIf="!removePallets">
  <mat-tab label="Relatório" *ngIf="!showPalletDetails">
    <div class="infos">
      <app-info-oc-or-nfe label="Data de emissão" [value]="getFormattedDate(report.createdAt)"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Número da Ordem" *ngIf="reportData.type === inventoryTypesEnum.INVENTORY_BY_OUT_ORDER" [value]="reportTarget?.outOrder?.no || '---'">
      </app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Realizado por" [value]="getUserName(report.user)"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Requisitado por" [value]="getUserName(report.admin)"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Tipo de inventário" [value]="translateTypeName(report.data.type)"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe *ngIf="reportData.type === inventoryTypesEnum.INVENTORY_BY_PRODUCT" label="Nome do produto" [value]="productName || '---'"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe *ngIf="reportData.type === inventoryTypesEnum.INVENTORY_BY_GROUND_POSITION_GROUP" label="Setor" [value]="formattedGroundPositionGroupName || '---'"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe
        *ngIf="reportData.type === inventoryTypesEnum.INVENTORY_BY_GROUND_POSITION || reportData.type === inventoryTypesEnum.INVENTORY_BY_PIGEONHOLE_POSITION"
        label="Posição"
        [value]="groundPositionName || '---'">
      </app-info-oc-or-nfe>
      <app-info-oc-or-nfe
        *ngIf="reportData.type === inventoryTypesEnum.INVENTORY_BY_PRODUCT"
        label="Código do Item"
        [value]="reportTarget?.skus?.[0] || '---'">
      </app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Total de itens" [value]="(totalItems | number:'1.0-0') || '---'"></app-info-oc-or-nfe>
    </div>

    <ng-container>
      <div class="table pallet-inventory" *ngIf="inventoryByCrateReportData">
        <section class="pallet-info-container">
          <app-pallet-details-modal [reportData]="inventoryByCrateReportData"></app-pallet-details-modal>
          <button mat-raised-button (click)="openPalletDetails(inventoryByCrateReportData.crate)">
            Dados Do Pallet
          </button>
        </section>
        <app-pallet-reports-table [items]="palletItems"></app-pallet-reports-table>
      </div>

      <div class="table others-inventory" *ngIf="!inventoryByCrateReportData">
        <app-reports-table-modal
          [items]="items"
          [report]="report"
          (openPalletDetails)="openPalletDetails($event)">
        </app-reports-table-modal>
      </div>

      <div class="buttons">
        <button mat-stroked-button class="gray-2" (click)="close('CANCELED')">cancelar</button>
        <button mat-raised-button class="alert" (click)="close('REJECTED')" [disabled]="report.state !== 'AWAITING_ADMIN_APPROVAL'">
          rejeitar
        </button>
        <button mat-raised-button class="primary-1" (click)="close('APPROVED')" [disabled]="report.state !== 'AWAITING_ADMIN_APPROVAL'">
          confirmar
        </button>
      </div>
    </ng-container>
  </mat-tab>
</mat-tab-group>

<app-map-pallet-details
  *ngIf="showPalletDetails && crateDetails"
  [data]="crateDetails"
  (relocateClicked)="onRelocateClicked($event)"
  (palletInventoryClicked)="onInventoryClicked($event)">
</app-map-pallet-details>

<section *ngIf="removePallets" class="missing-pallets-section">
  <p>Os seguintes pallets serão removidos do armazém:</p>
  <app-material-generic-table
    [displayedColumns]="displayedColumns"
    [columnsDefinition]="removedPalletColumnsDefinition"
    [dataSource]="removedPalletsDataSource"
    emptyDataMessage="Não existem pallets para remover">
  </app-material-generic-table>
  <div class="buttons">
    <button mat-stroked-button class="gray-2" (click)="removePallets = false">cancelar</button>
    <button mat-raised-button class="alert" (click)="confirmRemovePallets()">
      excluir
    </button>
  </div>
</section>